module.exports = __webpack_public_path__ + "img/rw_determine_right_wrong.3d700f9b.jpg";